import { render } from "./AppTablePaginator.vue?vue&type=template&id=5c0a6dc2&scoped=true"
import script from "./AppTablePaginator.vue?vue&type=script&lang=js"
export * from "./AppTablePaginator.vue?vue&type=script&lang=js"

import "./AppTablePaginator.vue?vue&type=style&index=0&id=5c0a6dc2&lang=scss&scoped=true"

import exportComponent from "/var/www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c0a6dc2"]])

export default __exports__